import { getToken } from "../../helper/common";
import agent from "../services/agent";
import { showSnackbarStatus } from "../snackbar/actions";
import { SET_DASHBOARD_DATA, SET_DASHBOARD_PENDING } from "./actionTypes";
// import { showSnackbarStatus } from "./snackbar.actions";


export const setDashboardPending = () => ({
    type: SET_DASHBOARD_PENDING,
});

const setDashboardData = (dashboardData) => ({
    type: SET_DASHBOARD_DATA,
    payload: { dashboardData },
});

export const getDashboardData = () => (dispatch) => {
    dispatch(setDashboardPending());
    getToken(dispatch).then((accessToken) => {
        agent.Dashboard.getDashboardData(accessToken)
            .then((dashboardData) => {
                dispatch(setDashboardData(dashboardData));
            })
            .catch((err) => {
                console.log("getRequests server error", err);
                dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
            });
    });
};
